<template>
  <div ref="carousel"
       class="relative z-10 inline-flex mt-6 space-x-6 whitespace-nowrap pb-[10px] overflow-scroll"
       :style="{ width: scrollContainerWidth}">
    <speaker-card v-for="speaker in speakers" :speaker="speaker"></speaker-card>
  </div>
</template>

<script>
import SpeakerCard from "./SpeakerCard.vue";

export default {
  components: {SpeakerCard},
  props: {
    speakers: {
      type: Array,
      default: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.resize);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      const width = window.screen.width - 20;

      if (width >= 1600) {
        this.scrollContainerWidth =  + '1600px';
      } else {
        this.scrollContainerWidth = width + 'px';
      }
    }
  },
  data() {
    return {
      scrollContainerWidth:  window.screen.width - 20 + 'px'
    }
  },
}
</script>

<style>
</style>
